import { colors } from '../../Pages/Sindico/colors';
import styled from 'styled-components';

export const StyledEmptyState = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 24px;
  height: 100%;
  margin: auto;

  .container-titles-empty-state {
    color: ${colors.gray[450]};
    text-align: center;

    .title-empty-state {
      font-size: 18px;
      font-weight: bold;
      display: block;
      margin-bottom: 8px;
    }

    .title-empty-state {
      font-size: 16px;
    }
  }
`;
